<button type="button" [ngClass]="color" class="btn rounded-pill {{size}}" [class.w-100]="btnFullWidth"
  [disabled]="disabled" (click)="handleClick()">
  <span class="svg-icon svg-icon-white pe-1 " *ngIf="icon">
    <svg-icon src="/assets/icons/svg/{{icon}}.svg"></svg-icon>
  </span>
  <span>
    {{title}}
  </span>
</button>
